import React from 'react';
import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://dision.tech';
const DEFAULT_IMAGE = '/pictures/Image_8_021c93e756.webp';
const SITE_NAME = 'DISION Tech LLC';

export default function SEOHead({
  title,
  description,
  keywords,
  image,
  url,
  type = 'website',
  noIndex = false,
  schema,
}) {
  const fullTitle = title ? `${title} | DISION Tech` : 'DISION Tech LLC – Custom Software Development & Cybersecurity';
  const metaDesc = description || 'DISION Tech provides innovative software development products and cybersecurity solutions for businesses of all sizes. DevNetOps, IT consulting, network security.';
  const metaImage = image || DEFAULT_IMAGE;
  const metaUrl = url ? `${BASE_URL}${url}` : BASE_URL;
  const metaKeywords = keywords || 'software development, cybersecurity, DevNetOps, IT consulting, network security, web application development, Vietnam, Ho Chi Minh';

  return (
    <Helmet>
      {/* Primary */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDesc} />
      <meta name="keywords" content={metaKeywords} />
      <meta name="author" content="DISION Tech LLC" />
      <link rel="canonical" href={metaUrl} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      {!noIndex && <meta name="robots" content="index, follow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDesc} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={metaUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDesc} />
      <meta name="twitter:image" content={metaImage} />
      <meta name="twitter:site" content="@disiontech" />

      {/* JSON-LD Structured Data */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}
